import { ActionType, createAction } from 'typesafe-actions'

import { OrderData, OrderItem } from '../order/types'

import { CountryDetail, PaymentOptions, PayPerClick, StateDetail } from './types'

export const CheckoutActions = {
  loadCheckoutOrder: createAction('CHECKOUT/load-order')<{ orderId?: string }>(),
  setCheckoutOrderData: createAction('CHECKOUT/set-order-data')<{ order: OrderData }>(),
  setCheckoutOrderItems: createAction('CHECKOUT/set-order-items')<{ items: OrderItem[] }>(),
  placeOrder: createAction('CHECKOUT/place-order')<{
    orderId: string
    resetCart: boolean
    customerReference?: string
    paymentMethod?: string
    returnUrl: string
    cancelUrl: string
  }>(),
  orderFailed: createAction('CHECKOUT/order-failed')<{ error: any }>(),
  orderPlaced: createAction('CHECKOUT/order-placed')<{ customerRequestIds: string[] }>(),
  loadCountries: createAction('CHECKOUT/load-countries')(),
  loadStates: createAction('CHECKOUT/load-states')<{ countryCode: string }>(),
  setCountries: createAction('CHECKOUT/set-countries')<{ countries: CountryDetail[] }>(),
  setStates: createAction('CHECKOUT/set-states')<{ states: StateDetail[] }>(),
  loadPaymentOptions: createAction('CHECKOUT/load-payment-options')<{ paymentOptionCode: string }>(),
  setPaymentOptions: createAction('CHECKOUT/set-payment-options')<{ paymentOptions: PaymentOptions }>(),
  setPayPerClick: createAction('CHECKOUT/set-pay-per-click')<{ payPerClick?: PayPerClick }>()
}

export type CheckoutActions = ActionType<typeof CheckoutActions>
